export default function ApprovalEmptyState() {
  return <span>No records found. Try changing filters.</span>
}
